import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<button type=\'button\' class={{this.qlClass}} ...attributes>{{yield}}</button>");

class QuillToolbarButtonComponent extends Component {
  get qlClass() {
    if (this.args.type) {
      return `ql-${this.args.type}`;
    }
    return null;
  }
}
setComponentTemplate(TEMPLATE, QuillToolbarButtonComponent);

export { QuillToolbarButtonComponent as default };
//# sourceMappingURL=button.js.map
